import { render, staticRenderFns } from "./TabsProducts.vue?vue&type=template&id=a7552fd0&"
import script from "./TabsProducts.vue?vue&type=script&lang=js&"
export * from "./TabsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports